import { Text, UnstyledButton } from '@mantine/core';
import { useNavigate } from 'react-router';

import { brand } from '../../branding';
import { useCatalogLabels } from '../labels';
import { useWishlist } from '../wishlist';
import {
    HEADER_OVERLAY_ROW_HEIGHT,
    HEADER_OVERLAY_TOP_CSS,
    HEADER_OVERLAY_Z_INDEX,
    rightInset,
    WISHLIST_INSET
} from './headerLayout';

// Overlays the Merkliste (wishlist) entry point into the DOKA header bar, just left of
// LanguageSwitch's language select - same fixed-position technique (see LanguageSwitch/HeaderBrand:
// the header bar itself comes from the private @uag/react-core blueprint, not this repo, so there
// is no prop to inject content next to it).
//
// Placement (WISHLIST_INSET, measured from the right edge of the viewport) and the reason it is
// expressed as `left: calc(100vw - ...)` rather than `right:` both live in headerLayout.ts, next to
// the language select's own inset so the two can't drift into each other.

export const HeaderWishlist = () => {
    const { L } = useCatalogLabels();
    const navigate = useNavigate();
    const { items } = useWishlist();

    return (
        <UnstyledButton
            aria-label={L.wishlist}
            // Hidden below `md` - same reasoning as HeaderBrand. WishlistIconCompact below is the
            // mobile stand-in, rendered by MobileHeaderBar.
            className="hidden items-center gap-1 md:flex"
            style={{
                position: 'fixed',
                top: HEADER_OVERLAY_TOP_CSS,
                left: rightInset(WISHLIST_INSET),
                height: HEADER_OVERLAY_ROW_HEIGHT,
                zIndex: HEADER_OVERLAY_Z_INDEX,
            }}
            title={L.wishlist}
            onClick={() => navigate('/catalog/wishlist')}
        >
            <span className="material-symbols-outlined" style={{ color: brand.headerForeground, fontSize: 20 }}>
                bookmark
            </span>
            <Text c={brand.headerForeground} fw={600}>
                {L.wishlist} ({items.length})
            </Text>
        </UnstyledButton>
    );
};

// Icon-only variant with a small count badge, used by MobileHeaderBar instead of the text+icon
// button above - "Merkliste (N)" is too wide for the mobile secondary bar next to the title and
// LanguageToggleCompact.
export const WishlistIconCompact = () => {
    const { L } = useCatalogLabels();
    const navigate = useNavigate();
    const { items } = useWishlist();

    return (
        <UnstyledButton
            aria-label={`${L.wishlist} (${items.length})`}
            className="relative flex items-center"
            title={L.wishlist}
            onClick={() => navigate('/catalog/wishlist')}
        >
            <span className="material-symbols-outlined" style={{ color: brand.primary, fontSize: 22 }}>
                bookmark
            </span>
            {items.length > 0 && (
                <span
                    className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold text-white"
                    style={{ backgroundColor: brand.primary }}
                >
                    {items.length}
                </span>
            )}
        </UnstyledButton>
    );
};
